import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import SideBar from "../Components/Dashboard/SideBar";
import PageLayout from "../Layouts/PageLayout";
import { Card, Tooltip } from "react-bootstrap";
import "../Styles/Admin.css";
import WelcomeImg from "../Assets/Images/WelcomeImg.png";
import RevenueIcon from "../Assets/Icons/revenueIcon.svg";
import MerchantIcon from "../Assets/Icons/merchantIcon.svg";
import CustomerIcon from "../Assets/Icons/customerIcon.svg";
import PendingIcon from "../Assets/Icons/pendingIcon.svg";
import RefundIcon from "../Assets/Icons/refundIcon.svg";
import AdminCard from "../Components/AdminCard";
import CalenderIcon from "../Assets/Icons/calenderIcon.svg";
import Form from "react-bootstrap/Form";
import {
  PieChart,
  Pie,
  Sector,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  AreaChart,
  Area,
} from "recharts";

const rangeData = [
  {
    day: "Sun",
    temperature: 2,
  },
  {
    day: "Mon",
    temperature: 4,
  },
  {
    day: "Tue",
    temperature: 2,
  },
  {
    day: "Wed",
    temperature: 4,
  },
  {
    day: "Thu",
    temperature: 5,
  },
  {
    day: "Fri",
    temperature: 7,
  },
  {
    day: "Sat",
    temperature: 3,
  },
];

const barChartData = [
  {
    name: "Jan",
    months: 25,
  },
  {
    name: "Feb",
    months: 20,
  },
  {
    name: "Mar",
    months: 30,
  },
  {
    name: "Apr",
    months: 35,
  },
  {
    name: "May",
    months: 40,
  },
  {
    name: "Jun",
    months: 45,
  },
  {
    name: "Jul",
    months: 50,
  },
  {
    name: "Aug",
    months: 55,
  },
  {
    name: "Sep",
    months: 60,
  },
  {
    name: "Oct",
    months: 65,
  },
  {
    name: "Sep",
    months: 70,
  },
  {
    name: "Dec",
    months: 55,
  },
];

const pieData = [
  { name: "27 Subscriptions", value: 400 },
  { name: "27 Subscriptions", value: 600 },
];
const PIE_COLORS = ["#FFA049", "#008BD9"];

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill} fontSize={12}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
};

export default function Admin() {
  const [activePie, setActivePie] = useState(0);
  return (
    <Container fluid>
      <PageLayout>
        <div>
          <div className="admin-card-con">
            <Card className="admin-card">
              <p>
                Welcome back, <span>ADMIN !</span>
              </p>
              <img src={WelcomeImg} alt="welcome-img" />
            </Card>
            <Card style={{ width: "100%" }} className="admin-card-two">
              <p>Total Revenue</p>
              <img src={RevenueIcon} alt="revenue" />
              <h3>₦ 15154646</h3>
            </Card>
          </div>
          <div className="admin-card-container">
            <AdminCard
              title="Total Merchants"
              img={MerchantIcon}
              id="41564"
              bottombarbg="#008BD9"
            />
            <AdminCard
              title="Total Customers"
              img={CustomerIcon}
              id="153413"
              bottombarbg="#008BD9"
            />
            <AdminCard
              title="Pending Requests"
              img={PendingIcon}
              id="4654"
              bottombarbg="#FF7A00"
            />
            <AdminCard
              title="Active Installments"
              img={MerchantIcon}
              id="1564"
              bottombarbg="#008BD9"
            />
            <AdminCard
              title="Refund"
              img={RefundIcon}
              id="₦ 155461564"
              bottombarbg="#FF7A00"
            />
          </div>
          <div className="graph-sec-one">
            <div style={{ width: "100%", height: "100%" }}>
              <p className="admin-graph-sec-one-heading">Daily Revenue</p>
              <Card className="admin-graph-sec-one-box">
                <div className="admin-graph-sec-one-dily-revenue">
                  <div className="admin-graph-sec-one-calender">
                    <img src={CalenderIcon} />
                    <p>Today’s Total revenue</p>
                  </div>
                  <p className="revenue-text">₦ 15154646.1255</p>
                </div>
                <div style={{ width: 200, height: 338 }} >
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={pieData}
                      activeIndex={activePie}
                      activeShape={renderActiveShape}
                      // cx={120}
                      // cy={200}
                      innerRadius={60}
                      outerRadius={80}
                      fill="#8884d8"
                      //   paddingAngle={5}
                      dataKey="value"
                      onMouseEnter={(_, index) => setActivePie(index)}
                    >
                      {pieData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={PIE_COLORS[index % PIE_COLORS.length]}
                        >
                          dadsd
                        </Cell>
                      ))}
                    </Pie>
                    adas
                  </PieChart>
                  </ResponsiveContainer>
                </div>
              </Card>
            </div>
            <div style={{ width: "100%", height: "100%" }}>
              <p className="admin-graph-sec-one-heading">Weekly Revenue</p>
              <Card className="admin-graph-sec-three-box">
                <div className="admin-graph-sec-one-dily-revenue">
                  <div className="admin-graph-sec-two">
                    <p>₦ 15154646.1255</p>
                    <Form.Select
                      className="admin-select"
                      style={{
                        width: "7.6rem",
                        height: "2.5rem",
                        border: "2px solid #008BD9",
                        fontWeight: "bold",
                        color: "#0085FF",
                        fontSize: "0.80rem",
                      }}
                      controlId="exampleForm.SelectCustom"
                      aria-label="Default select example"
                    >
                      <option>This week</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </Form.Select>
                  </div>
                </div>
                <div style={{ width: "100%", height: 300 }} >
                  <ResponsiveContainer width="100%" height="100%">
                    <AreaChart
                      data={rangeData}
                      margin={{
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20,
                      }}
                    >
                      <defs>
                        <linearGradient
                          id="colorUv"
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="1"
                        >
                          <stop
                            offset="2%"
                            stopColor="#5D2ACB"
                            stopOpacity={0.35}
                          />
                          <stop
                            offset="100%"
                            stopColor="#4E26A4"
                            stopOpacity={0}
                          />
                        </linearGradient>
                      </defs>
                      <Area
                        type="basis"
                        dataKey="temperature"
                        fillOpacity={1}
                        strokeWidth={2}
                        stroke="#008BD9"
                        fill="url(#colorUv)"
                      />
                      <XAxis dataKey="day" axisLine={false} tickLine={false} />
                    </AreaChart>
                  </ResponsiveContainer>
                </div>
              </Card>
            </div>
          </div>
          <div style={{marginTop: '1rem'}}>
            <p className="admin-graph-sec-one-heading">
              Total yearly and monthly Revenue
            </p>
            <Card className="admin-graph-sec-two-box">
              <div className="yearly-graph-box-header-con">
                <div className="yearly-graph-box-header">
                  <p>Total Revenue</p>
                  <h3>₦ 15154646.1255</h3>
                </div>
                <Form.Select
                  className="admin-select"
                  style={{
                    width: "8.1rem",
                    height: "2.5rem",
                    border: "2px solid #008BD9",
                    fontWeight: "bold",
                    color: "#0085FF",
                    fontSize: "0.80rem",
                  }}
                  controlId="exampleForm.SelectCustom"
                  aria-label="Default select example"
                >
                  <option>2022</option>
                  <option value="1">2021</option>
                  <option value="2">2020</option>
                  <option value="3">2019</option>
                </Form.Select>
              </div>
              <div style={{ width: "100%", height: 400 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={barChartData} barSize={30}>
                    <Bar dataKey="months" fill="#008BD9" radius={8} />
                    <Tooltip cursor={false} />
                    <XAxis dataKey="name" axisLine={false} tickLine={false} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </Card>
          </div>
        </div>
      </PageLayout>
    </Container>
  );
}
